<template>
  <div class="result text-center">
    <h3>3/14科教館布豐投針實驗</h3>
    <v-row no-gutters class="justify-center">
      <v-col cols="4" md="4" class="board">
        <v-hover v-slot="{ hover }">
        <v-card  :elevation="hover ? 5 : 2"
          :class="{ 'on-hover': hover }">
          <v-card-text>
            <div>投擲次數</div>
            <p class="display-1 text--primary">{{ animated_total_throw }}</p>
          </v-card-text>
        </v-card>
        </v-hover>
      </v-col>
      <v-col cols="4" md="4" class="board">
        <v-hover v-slot="{ hover }">
        <v-card  :elevation="hover ? 5 : 2"
          :class="{ 'on-hover': hover }">
          <v-card-text>
            <div>相交次數</div>
            <p class="display-1 text--primary">{{ animated_total_cross }}</p>
          </v-card-text>
        </v-card>
        </v-hover>
      </v-col>
      <v-col cols="4" md="4" class="board">
        <v-hover v-slot="{ hover }">
        <v-card  :elevation="hover ? 5 : 2"
          :class="{ 'on-hover': hover }">
          <v-card-text>
            <div>界外</div>
            <p class="display-1 text--primary">{{ animated_total_out }}</p>
          </v-card-text>
        </v-card>
        </v-hover>
      </v-col>
    </v-row>
    <v-row no-gutters class="justify-center">
      <v-col cols="12" sm="12" class="board">
        <v-hover v-slot="{ hover }">
        <v-card  :elevation="hover ? 5 : 2"
          :class="{ 'on-hover': hover }">
          <v-card-text>
            <p class="display-1 text--primary"><katex-element expression="\\\pi\approx"/> {{ est_pi }}</p>
          </v-card-text>
        </v-card>
        </v-hover>
      </v-col>
    </v-row>
    <v-row justify="center" class="reply">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
      class="reply-modal"
      style='z-index:1100;'
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          點我輸入科教館實驗數據
        </v-btn>
      </template>
      <v-card >
        <v-card-title>
          <span class="headline">數據回報</span>
        </v-card-title>
        
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                  label="投擲次數*"
                  type="number"
                  v-model="in_total_throw"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="相交次數*"
                  type="number"
                  v-model="in_total_cross"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="出界次數*"
                  type="number"
                  v-model="in_total_out"
                  required
                ></v-text-field>
              </v-col>
            <v-col cols="12">
              <v-text-field
            v-model="in_est_pi"
            label='圓周率預估值'
            outlined
            readonly
          ></v-text-field>
          </v-col>
            </v-row>
          </v-container>
          <small>*必填</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="btnclose"
          >
            關閉
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="btnenter"
          >
            輸入
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </div>
</template>
<style  scoped>
.result{
  padding-top: 100px;
}
.board {
  padding-left: 10px!important;
  padding-right: 10px!important;
  padding-top:20px!important;
}
.check_outlier{
  padding-top:30px!important;

}
.slider{
  padding-top:50px!important;

}
.v-card[class*="elevation-"]:before {
  display: block;
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
}
.v-card.elevation-2:before {
  background: rgba(255, 255, 255, 0.02)
}
.v-card.elevation-5:before {
  background: rgba(255, 255, 255, 0.05)
}


</style>
<script>
  import { gsap } from "gsap";

  export default {
    inject: ["eventHub"],
    name: "Result",
    data: () => ({
      dialog: false,
      total_throw:4000,
      total_cross:0,
      total_out:0,
      in_total_throw:4000,
      in_total_cross:0,
      in_total_out:0,
    }),
    computed: {
    // a computed getter
      factor: function(){
        return 10/10.4
      },
      est_pi: function () {
        if(this.total_cross == 0){
          return '？'
        }else{
          return Math.round(2*(this.total_throw.toFixed(0)-this.total_out.toFixed(0))/this.total_cross.toFixed(0)*this.factor*10000000)/10000000
        }
      },
      animated_total_throw:function(){
        return this.total_throw.toFixed(0);
      },
      animated_total_cross:function(){
        return this.total_cross.toFixed(0);
      },
      animated_total_out:function(){
        return this.total_out.toFixed(0);
      },
      in_est_pi:function(){
        if(this.in_total_cross == 0){
          return '？'
        }else{
          return Math.round(2*(this.in_total_throw-this.in_total_out)/this.in_total_cross*this.factor*10000000)/10000000
        }
      }
    },
    methods:{
      btnclose : function(){
        this.dialog = false;
      },
      btnenter : function(){
        this.dialog = false;
        this.eventHub.$emit('factor',{ outrate:this.in_total_out/this.in_total_throw })
        setTimeout(()=>{ 
                gsap.to(this.$data, { duration: 0.5, total_throw: this.in_total_throw ,total_cross:this.in_total_cross, total_out:this.in_total_out});
              }, 800);
      }
    }
  }
</script>